import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Header, Sidebar } from "../Layout";
import { Link } from 'react-router-dom'
import { getAdminDashboardStats } from '../../../actions/adminActions';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const AdminDashboard = () => {
    const dispatch = useDispatch()
    const { dashboard } = useSelector(state => state.adminStore)
    useEffect(() => {
        dispatch(getAdminDashboardStats())
    }, [dispatch])

    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Dashboard</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Dashboard</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">

                    <div className="row clearfix">
                        <div className="col-12">
                            <div className="card top_report">
                                <div className="row clearfix">
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="body">
                                            <div className="clearfix">
                                                <div className="float-left">
                                                    <i className="fa fa-2x fa-dollar text-col-blue"></i>
                                                </div>
                                                <div className="number float-right text-right">
                                                    <h6>Current Month Revenue</h6>
                                                    <span className="font700">${dashboard?.monthlyRevenue || 0}</span>
                                                </div>
                                            </div>
                                            <div className="progress progress-xs progress-transparent custom-color-blue mb-0 mt-3">
                                                <div className="progress-bar" data-transitiongoal="87"></div>
                                            </div>
                                            {/* <small className="text-muted">19% compared to last week</small> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="body">
                                            <div className="clearfix">
                                                <div className="float-left">
                                                    <i className="fa fa-2x fa-user text-col-green"></i>
                                                </div>
                                                <div className="number float-right text-right">
                                                    <h6>Registered Users</h6>
                                                    <span className="font700">{dashboard?.registeredUsers || 0}</span>
                                                </div>
                                            </div>
                                            <div className="progress progress-xs progress-transparent custom-color-green mb-0 mt-3">
                                                <div className="progress-bar" data-transitiongoal="28"></div>
                                            </div>
                                            {/* <small className="text-muted">19% compared to last week</small> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="body">
                                            <div className="clearfix">
                                                <div className="float-left">
                                                    <i className="fa fa-2x fa-user text-col-red"></i>
                                                </div>
                                                <div className="number float-right text-right">
                                                    <h6>Total Verified Users</h6>
                                                    <span className="font700">{dashboard?.verifiedUsers || 0}</span>
                                                </div>
                                            </div>
                                            <div className="progress progress-xs progress-transparent custom-color-red mb-0 mt-3">
                                                <div className="progress-bar" data-transitiongoal="41"></div>
                                            </div>
                                            {/* <small className="text-muted">19% compared to last week</small> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="body">
                                            <div className="clearfix">
                                                <div className="float-left">
                                                    <i className="fa fa-2x fa-user text-col-yellow"></i>
                                                </div>
                                                <div className="number float-right text-right">
                                                    <h6>Total UnVerified Users</h6>
                                                    <span className="font700">{dashboard?.unVerifiedUsers || 0}</span>
                                                </div>
                                            </div>
                                            <div className="progress progress-xs progress-transparent custom-color-yellow mb-0 mt-3">
                                                <div className="progress-bar" data-transitiongoal="75"></div>
                                            </div>
                                            {/* <small className="text-muted">19% compared to last week</small> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="header bline">
                                    <h2>Revenue Overview For Current Year</h2>

                                </div>
                                <div className="body">
                                    <ResponsiveContainer width="100%" height={400}>
                                        <LineChart
                                            width={500}
                                            height={200}
                                            data={dashboard?.yearlyRevenue}
                                            margin={{
                                                top: 10,
                                                right: 30,
                                                left: 0,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="month" />
                                            <YAxis />
                                            <Tooltip />
                                            <Line connectNulls type="monotone" dataKey="amount" stroke="#8884d8" fill="#8884d8" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-md-12">
                            <div className="card">
                                <div className="header">
                                    <h2>Top Projects</h2>
                                </div>
                                <div className="body">
                                    <div id="chart-top-products" className="chartist"></div>
                                </div>
                            </div>
                        </div> */}

                    </div>

                </div>
            </div>

        </>

    );
}

export default AdminDashboard;
